import { render, staticRenderFns } from "./EntityAccessTypeIcon.vue?vue&type=template&id=07616004&"
import script from "./EntityAccessTypeIcon.vue?vue&type=script&lang=js&"
export * from "./EntityAccessTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports